<script>
    import PinnedMap from "./pinned_map.svelte";
    import PinnedMap3D from "./pinned_map_3D.svelte";

    import JoystickController from "joystick-controller";
    import Search from "carbon-icons-svelte/lib/Search.svelte";
    import AddLarge from "carbon-icons-svelte/lib/AddLarge.svelte";
    import SubtractLarge from "carbon-icons-svelte/lib/SubtractLarge.svelte";

    import { magnify_levels, current_magnify_level } from "../store";
    import { onMount } from "svelte";

    let joystick;
    let moveX, moveY;
    let pinching = false;
    let start_pinch = 0;
    let end_pinch = 0;

    const magnify = (value) => {
        if(($current_magnify_level == 0 && value == -1) || (($current_magnify_level == $magnify_levels.length - 1) && value == +1)) return
        $current_magnify_level += value;
    }

    let _3D = false;

    onMount(()=>{
        joystick = new JoystickController(
        {
            maxRange: 70,
            level: 10,
            radius: 50,
            joystickRadius: 30,
            opacity: 0,
            containerClass: "joystick-container",
            controllerClass: "joystick-controller",
            joystickClass: "joystick",
            distortion: true,
            dynamicPosition: true,
            dynamicPositionTarget: document.getElementById("pinned-map-wrapper"),
            mouseClickButton: "ALL",
            hideContextMenu: true,
        },
        ({ x, y, leveledX, leveledY, distance, angle }) => {
            if(pinching)
                moveX = moveY = 0;
            else{
                moveX = leveledX;
                moveY = leveledY;
            }
        });


        let urlParams = new URLSearchParams(window.location.search);
        _3D = urlParams.has('3d');
    })

    const map_touchstart = (e) => {
        if (e.touches.length === 2) {
            pinching = true;
            start_pinch = Math.hypot(
            e.touches[0].pageX - e.touches[1].pageX,
            e.touches[0].pageY - e.touches[1].pageY);
        }
    }
    const map_touchmove = (e) => {
        if(!pinching) return;
        end_pinch = Math.hypot(
        e.touches[0].pageX - e.touches[1].pageX,
        e.touches[0].pageY - e.touches[1].pageY);
    }
    const map_touchend = (e) => {
        if(pinching) {
            pinching = false;

            if(start_pinch > end_pinch){
                magnify(-1)
            }else{
                magnify(+1)
            }
        }
    }

</script>
<div class='pinned-map-wrapper' id="pinned-map-wrapper">
    <div id="pinned-map-visible-area" 
    on:touchstart={(e)=>{map_touchstart(e)}}
    on:touchmove={(e)=>{map_touchmove(e)}}
    on:touchend={(e)=>{map_touchend(e)}}>
        <PinnedMap3D 
            bind:moveX
            bind:moveY/>
    </div>
    <div class='magnify-controller'>
        <div class='magnify-button minus {$current_magnify_level==0?'disabled':''}' on:click={()=>magnify(-1)}>
            <SubtractLarge/>
        </div>
        <div><Search/></div>
        <div class='magnify-button plus {$current_magnify_level==$magnify_levels.length-1?'disabled':''}' on:click={()=>magnify(+1)}>
            <AddLarge/>
        </div>
    </div>
</div>

<style lang="scss">
    .pinned-map-wrapper{
        position: relative;
        flex-grow: 1;
        width: 100%;
        padding-bottom: 2vh;

        .area-move{
            position: absolute;
            width: 10%;
            top: 0;
            height: 100%;
            color: #fff9;
            display: flex;
            align-items: center;
            justify-content: center;

            &#move-left{
                left: 0;
            }

            &#move-right{
                right: 0;
            }
        }

        #pinned-map-visible-area{
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: absolute;
            top: 0;
            left: 0%;
            display: flex;
            align-items: center;
            justify-content: center;
       }
    }

    .magnify-controller{
        position: absolute;
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
        justify-content: center;
        align-items: center;
        width: clamp(90px, 2vw, 120px);   
        background: #fff8;
        padding: 10px;
        border-radius: 60px;
        bottom: 60px;
        right: 10px;
        backdrop-filter: blur(2px);
        box-shadow: 0px 0px 3px #0007;

        display: none;
       
        & > div{
            display: flex;
            justify-content: center;
            align-items: center;

            &.disabled{
                color: gray;
            }
        }
    }

    :global(.joystick-container){
        z-index: -1;
    }
</style>
